import { useEffect } from 'react';
import type React from 'react';

import { isModalOpen } from 'src/utils/is-modal-open';
import analyticsClient, { AnalyticsEvent } from 'src/services/analytics';
import { isMac } from 'src/common/utils';

export const useFocusOnCtrlK = (inputRef: React.RefObject<HTMLInputElement>, page: string) => {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            const isModifierPressed = isMac() ? event.metaKey : event.ctrlKey;
            if (event.key === 'k' && isModifierPressed) {
                if (isModalOpen()) {
                    return;
                }

                const keyLabel = isMac() ? '⌘K' : 'Ctrl+K';
                analyticsClient.track(AnalyticsEvent.SHORTCUT_KEY_USED, {
                    page,
                    key: keyLabel,
                });

                event.preventDefault();
                inputRef.current?.focus();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, []);
};
